<template>
	<ArticleCard :article="article" :classes="classes">
		<ArticleCoverImage v-if="coverImage" :cover-image="coverImage" />
		<p
			v-if="showDate"
			class="overline mt-50"
			:class="{
				'display-flex align-items-center': article.showNewBadge
			}"
		>
			<ArticleDate :date-string="article.date || article._createdAt" />
			<Badge v-if="article.showNewBadge" class="ml-50" background="slate" text="New" size="medium" />
		</p>
		<p
			v-else-if="categoryName"
			class="overline mt-225"
			:class="{
				'display-flex align-items-center': article.showNewBadge
			}"
		>
			{{ categoryName }}
			<Badge v-if="article.showNewBadge" class="ml-50" background="slate" text="New" size="medium" />
		</p>
		<h1 class="article-title heading-1 mt-25 mb-100">
			{{ title }}
		</h1>
		<p v-if="abstract" class="body-lg" v-html="abstract"></p>
	</ArticleCard>
</template>

<script setup lang="ts">
import ArticleCard from '@components/blog/article-card.vue';
import ArticleCoverImage from '@components/blog/article-cover-image.vue';
import ArticleDate from '@components/blog/article-date.vue';
import Badge from '@components/badges/badge-component.vue';
import { computed } from 'vue';
import { SanityArticleTeaser } from 'types/sanity/education-center';
import { SanityAsset } from 'types/sanity';

interface Props {
	article: SanityArticleTeaser;
	classes?: string;
	showDate?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
	classes: '',
	showDate: false
});

const coverImage = computed((): SanityAsset | null => {
	return props.article.coverImage?.asset || null;
});

const categoryName = computed((): string => {
	return props.article?.category?.name || '';
});

const title = computed((): string => {
	return props.article.title;
});

const abstract = computed((): string => {
	return props.article?.abstract || '';
});
</script>
